<template>
  <div class="container text-center py-6 py-lg-10">
    <div class="row align-items-center justify-content-center">
      <div class="col-10 col-sm-8 col-md-6 col-lg-6 col-xl-5">
        <h1 class="title mb-2">
          {{ $t('pages.checkins_list.tips_form_title_1') }}
        </h1>
        <h3 class="subtitle">{{
            $t('pages.checkins_list.tips_form_subtitle')
          }}</h3>
        <div class="row mt-4">
          <div class="col-lg-8 offset-lg-2">
            <CheckinMaker :dismissible="false"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import CheckinMaker from '@/domain/checkin/CheckinMaker'

export default {
  components: {
    CheckinMaker,
  },
}
</script>
